import React, { useState, useEffect, useCallback } from 'react';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Userlist from '../../components/UserListComponent/Userlist';
import Courselist from '../../components/CourseListComponent/Courselist';
import Chapterlist from '../../components/ChapterListComponent/Chapterlist';
import Videolist from '../../components/VideoListComponent/Videolist';
import { Box } from '@mui/system';
import Loader from '../Loader/Loader';
import axios from 'axios';

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#F2F2F2',
  ...theme.typography.body2,
  //   padding: `calc(1em + ${theme.spacing(1)})`,
  padding: theme.spacing('70px 0 0 250px'),
  borderRadius: 0,
  boxShadow: 'none !important',
  fontSize: 20,
  fontWeight: 'bold',
  color: '#004A99',
  height: '2000px',
}));

const VideoList = () => {
  const [render, setRender] = useState(false);
  const [pending, setPending] = useState(false);

  const [courseList, setCourseList] = useState([]);

  /////////////////////// Taking courses from API
  const getCourseList = async () => {
    try {
      setPending(true);
      const res = await axios.get(`api/v1/courses`);
      setCourseList(res.data.courses);
      setPending(false);
    } catch (error) {
      console.log('error', error);
    }
  };

  useEffect(() => {
    getCourseList();
  }, []);

  ////////////////////////////////// Taking videos from API
  // const getVideoList = () => {
  //   setPending(true);

  //   fetch(
  //     `api/v1/a34jl49u-q4r67p89/courses/03160837-4207-4a47-b45f-2be62a2c99e9/chapter/62a8a3624fd5c4be6d905ff5/video`
  //   )
  //     .then((response) => response.json())
  //     .then((res) => {
  //       console.log('running video res', res);
  //       setVideoList(res.videos);
  //       setPending(false);
  //     })
  //     .catch((err) => console.log('err', err));
  // };

  // useEffect(() => {
  //   getVideoList();
  // }, [render]);

  return (
    <Item>
      <Box sx={{ padding: '18px' }}>
        {!pending ? (
          <Videolist
            render={render}
            setRender={setRender}
            courseList={courseList}
          />
        ) : (
          <Loader />
        )}
      </Box>
      {/* <Typography>User Lists</Typography> */}
    </Item>
  );
};

export default VideoList;
